import React from 'react'

const Question = (props) => {
    return (<>
        {props && props.productId && props.dlProduct == false && props.prodType != "CBS Family" ?
            <section class="col-12 accordion-item pdp-detail-questions" id="qAndA">
                <h2 class="d-block d-md-none accordion-header" id="pdp-qAndA-heading">
                    <button id="qAndA_accordion_button" class=" pdp accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#pdp-qAndA-body" aria-expanded="true" aria-controls="pdp-qAndA-body">
                        Questions &amp; Answers
                    </button>
                </h2>
                <div id="pdp-qAndA-body" class="accordionIsTablet accordion-collapse collapse " aria-labelledby="pdp-qAndA-heading" data-bs-parent="#pdp-detail-accordion" >
                    <div class="accordion-body">
                        <div data-bv-show="questions" data-bv-product-id={props &&props.productId}>
                        </div>
                    </div>
                </div>
            </section> : ""}
    </>
    )
}

export default Question